import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Sparkles } from "lucide-react";
import AchievementBadge from "@/components/badges/AchievementBadge";
import { COACH_BADGE_CATEGORIES } from "@/lib/badges";

export default function CoachStudentContributions({ studentId }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/badges/student/${studentId}/coach-contributions`)
      .then((r) => setData(r.data))
      .catch(() => setData({ contributions: [] }));
  }, [studentId]);

  const items = (data?.contributions || []).filter((c) => !c.already_earned);

  if (!items.length) return null;

  return (
    <Card className="border-emerald-100 bg-emerald-50/30 mt-6" data-testid="coach-student-contributions">
      <CardContent className="p-5">
        <div className="flex items-center gap-2 mb-4">
          <Sparkles className="w-4 h-4 text-emerald-600" />
          <h3 className="font-semibold text-slate-900">Badges que cet élève peut t'aider à débloquer</h3>
        </div>
        <div className="grid sm:grid-cols-3 gap-4">
          {items.map((item) => (
            <div key={item.badge_code} className="flex flex-col items-center text-center gap-2 p-3 rounded-xl bg-white/80">
              <AchievementBadge
                title={item.title}
                description={item.description}
                icon={item.icon}
                category={item.category}
                categories={COACH_BADGE_CATEGORIES}
                earned={false}
                progress={item.coach_progress}
                size="sm"
              />
              {item.student_metric?.label && (
                <p className="text-[10px] text-emerald-700 font-medium">
                  {item.student_metric.label} : {item.student_metric.current}/{item.student_metric.target}
                </p>
              )}
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}